import { PagingDataGrid } from "./PagingDataGrid";
export default PagingDataGrid;
